import React from 'react';
import { Box, BoxProps } from '@mantine/core';

/**
 * Root container for Content and Actions
 * @see WizardStepContent
 * @see WizardStepActions
 *
 * @example
 * ```tsx
 * <WizardStepRoot>
 *   <WizardStepContent>
 *     // Content
 *   </WizardStepContent>
 *   <WizardStepActions>
 *     // Actions buttons
 *   </WizardStepActions>
 * </WizardStepRoot>
 * ```
 */
export const WizardStepRoot: React.FC<BoxProps> = ({
  children,
  sx,
  ...boxProps
}) => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      maxHeight: '100%',
      overflow: 'hidden',
      display: 'grid',
      gridTemplateRows: '1fr auto',
      gap: 16,
      ...sx,
    }}
    {...boxProps}
  >
    {children}
  </Box>
);
